import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  getCategoryDataApi,
  getInventorySearchAPI,
  uploadBomFileAPI,
} from "../Home-Page/home-page.component.service";
import { useSelector, useDispatch } from "react-redux";
import HeaderTemplate from "./header.template";
import { getJsonDetailsAPI } from "../../service/site.service";
import {
  storeManufacturers,
  storeCategories,
  storeSettings,
  setBootstrapDone,
} from "../../reducers/app.reducer";

const HeaderComponent = ({ onClick }) => {
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dispatch = useDispatch();
  const { manufacturers, categories, settings } = useSelector(
    (state) => state.app
  );
  const { cart } = useSelector((state) => state.app);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isMobileCheck, setIsMobileCheck] = useState(false);
  const [categoryCounts, setCategoryCounts] = useState([]);
  const navigate = useNavigate();
  const { bootstrapDone } = useSelector((state) => state.app);
  // const history = useHistory();

  const onLoad = useCallback(async () => {
    try {
      setLoading(true);

      // Get settings
      const settingsRes = await getJsonDetailsAPI();
      console.log("Settings response:", settingsRes);
      if (settingsRes.status) {
        dispatch(storeSettings(settingsRes.data));
      }

      // Get categories and manufacturers
      const categoriesRes = await getCategoryDataApi();
      console.log("Categories response:", categoriesRes);

      if (categoriesRes.status) {
        // Make sure we're accessing the data correctly
        const categoriesData = categoriesRes.data?.categories || [];
        const manufacturersData = categoriesRes.data?.manufacturers || [];

        dispatch(storeCategories(categoriesData));
        dispatch(storeManufacturers(manufacturersData));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      console.log("Loading set to false");
    }
  }, [dispatch]);

  useEffect(() => {
    if (
      !bootstrapDone ||
      categories?.length === 0 ||
      manufacturers?.length === 0
    ) {
      onLoad();
      dispatch(setBootstrapDone());
    }
  }, [
    bootstrapDone,
    categories?.length,
    manufacturers?.length,
    dispatch,
    onLoad,
  ]);

  const handleNavigateAccount = () => {
    console.log("Navigate to account");
    navigate("/account");
  };

  const handleNavigateCart = () => {
    console.log("Navigate to cart");
    navigate("/cart");
  };
  console.log({ categories });

  const handleNavigateInventory = (category) => {
    setActiveDropdown(null);
    setIsMobileCheck(false); // Close mobile menu
    console.log("category unique id", category.unique_id);
    navigate(`/inventory/${category.unique_id}`);
  };

  const handleSearch = async () => {
    if (!searchQuery.trim()) return;
    setActiveDropdown(null);
    setIsMobileCheck(false);
    navigate(`/product-search/${encodeURIComponent(searchQuery.trim())}`);
    // try {
    //   const result = await getInventorySearchAPI({ keyword: searchQuery });
    //   console.log({ result });

    //   if (result.status) {
    //     setCategoryCounts(result?.data?.category_match_counts?.result);
    //     navigate(`/product-search/${searchQuery}`);
    //   } else {
    //     console.log("No products found");
    //   }
    // } catch (error) {
    //   console.error("Search failed:", error);
    //   // Handle error state if needed
    // }
  };
  console.log({ categoryCounts });

  const handleMobile = async () => {
    setIsMobileCheck(!isMobileCheck);
  };

  const handleFileUpload = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const files = e.target.files;
      const uploadResp = await uploadBomFileAPI(files);
      if (uploadResp.status) {
        setShowUploadModal(false); 
        navigate("/bom-column-mapping/" + uploadResp.data.bom.unique_id);
      }
    }
  };
  // console.log({ categories });

  const templateData = {
    manufacturers,
    categories,
    loading,
    searchQuery,
    searchResults,
    showUploadModal,
    selectedFile,
    cart,
    settings,
    isMobileCheck,
    activeDropdown,
  };

  const templateEvent = {
    handleSearch,
    handleFileUpload,
    setShowUploadModal,
    setSelectedFile,
    setSearchQuery,
    handleNavigateAccount,
    handleNavigateCart,
    handleMobile,
    handleNavigateInventory,
    setActiveDropdown,
  };

  return (
    <HeaderTemplate 
    templateData={templateData} 
    templateEvent={templateEvent} 
    />
  );
};

export default HeaderComponent;
